<template>
  <div class="column-selector">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          text
          v-bind="attrs"
          v-on="on"
          class="column-selector__trigger mr-2"
          width="18"
          height="18"
          @click="dialog = true"
        >
          <v-icon>mdi-cog-box</v-icon>
        </v-btn>
      </template>
      <span>Настройка таблицы</span>
    </v-tooltip>

    <v-dialog v-model="dialog" max-width="560" content-class="column-selector-dialog dialog-border-radius" persistent>
      <v-card class="column-selector-card">
        <div class="column-selector-card__title">
          <v-icon left class="column-selector-card__icon">mdi-view-column</v-icon>
          <span class="column-selector-card__label">Выберите отображаемые столбцы</span>
          <v-btn icon class="column-selector-card__close" @click="onCancel">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="column-selector-card__content">
          <div class="column-selector-list">
            <div
              v-for="header in availableHeaders"
              :key="header.value"
              class="column-selector-item"
              role="button"
              tabindex="0"
              @click="toggleColumn(header.value)"
              @keydown.enter.space.prevent="toggleColumn(header.value)"
            >
              <v-checkbox
                :label="header.text"
                :input-value="localVisibleColumns.includes(header.value)"
                hide-details
                dense
                color="primary"
                class="column-selector-item__checkbox mt-0"
                readonly
                @click.native.prevent
              />
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="column-selector-card__actions">
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="onCancel">Отмена</v-btn>
          <v-btn color="primary" class="text-none" rounded depressed @click="applySelection">
            Применить
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ColumnSelector',
  props: {
    visibleColumns: {
      type: Array,
      default: () => [],
    },
    availableColumns: {
      type: Array,
      default: () => [],
    },
    allColumns: {
      type: Array,
      default: () => [],
    },
    tableKey: String,
  },
  data () {
    return {
      dialog: false,
      localVisibleColumns: [],
    };
  },
  watch: {
    visibleColumns: {
      immediate: true,
      handler (newVal) {
        this.localVisibleColumns = JSON.parse(JSON.stringify(newVal));
      },
    },
  },
  computed: {
    ...mapGetters({
      userId: 'userId',
    }),
    availableHeaders () {
      return this.allColumns.filter(col => this.availableColumns.includes(col.value));
    },
  },
  methods: {
    ...mapActions({
      updateSettingTable: 'User/updateSettingTable',
      getAllSettingsTables: 'User/getAllSettingsTables',
    }),
    toggleColumn (value) {
      const idx = this.localVisibleColumns.indexOf(value);
      if (idx === -1) {
        this.localVisibleColumns = [...this.localVisibleColumns, value];
      } else {
        this.localVisibleColumns = this.localVisibleColumns.filter(v => v !== value);
      }
    },
    applySelection () {
      const selected = [...this.localVisibleColumns];
      this.$emit('update:visibleColumns', selected);

      this.updateSettingTable({
        id: this.userId,
        table_key: this.tableKey,
        visible_columns: selected,
      })
        .then(() => {
          this.$flash_danger('Таблица обновлена.');
          this.getAllSettingsTables();
        })
        .catch(error => {
          console.error(error);
        });

      this.dialog = false;
    },

    onCancel () {
      this.dialog = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.column-selector-card {
  border-radius: 12px;
  overflow: hidden;
}

.column-selector-card__title {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 52px;
  padding: 12px 48px 12px 16px;
  background: linear-gradient(135deg, #5a7a9e 0%, #4a6a8e 50%, #3d5a7d 100%);
  color: #fff;
  font-size: 1.1rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.column-selector-card__icon {
  margin-right: 10px;
  opacity: 0.95;
}

.column-selector-card__label {
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.column-selector-card__close {
  position: absolute;
  top: 50%;
  right: 8px;
  margin-top: -20px;
  color: rgba(255, 255, 255, 0.9) !important;

  &:hover {
    color: #fff !important;
    background: rgba(255, 255, 255, 0.15) !important;
  }
}

.column-selector-card__content {
  padding: 16px 20px !important;
  max-height: 60vh;
  overflow-y: auto;
}

.column-selector-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 2px 16px;
}

.column-selector-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 6px 0;
  margin: 0;
  border-radius: 6px;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
}

.column-selector-item__checkbox {
  flex: 1;
}

.column-selector-item__checkbox ::v-deep .v-label {
  font-size: 0.9rem;
  color: #37474f;
}

.column-selector-card__actions {
  padding: 12px 20px 16px !important;
  border-top: 1px solid #eee;
}
</style>
